// ─── Scroll-jump detector ─────────────────────────────────────────────────────
// Distinguishes reading scroll from instant jumps — back-navigation scroll
// restore (ScrollRestoration.js), anchor jumps, scrollbar seeks. Any single
// scroll event that moves more than one viewport-height is a jump; Reveal and
// useInView consult this to show content instantly right after one. Entrance
// animations are for content the reader scrolls to, not for content the
// browser teleports to — without this, a restored mid-page position replays
// every entrance and leaves the bottom quarter of the viewport invisible
// (the trigger observer's shrunken root never sees elements that appear there
// without crossing its line).
let lastJumpAt = -Infinity;

if (typeof window !== 'undefined') {
  let lastY = window.scrollY;
  window.addEventListener(
    'scroll',
    () => {
      const y = window.scrollY;
      if (Math.abs(y - lastY) > window.innerHeight) lastJumpAt = performance.now();
      lastY = y;
    },
    { passive: true }
  );
}

// IO deliveries normally land within a frame of the jump, but can lag well
// behind it when the tab is occluded or busy. Missing the window leaves
// content invisibly stuck in the viewport (the worse failure by far), while an
// over-wide window merely turns an entrance animation into an instant show for
// elements entered right after a jump — so err generously.
export const recentScrollJump = () => performance.now() - lastJumpAt < 1000;

// Meaningful visibility — used for the mount-time check and for accepting a
// jump entry (the trigger observer's root is shrunken and can't answer this).
// The 8px tolerance keeps elements that merely straddle the fold by a
// sub-pixel rounding (the trust bar sits exactly at the 100vh hero's edge)
// out of the instant-show path, so their entrance still animates
// deterministically on the next reading scroll.
const EDGE_TOLERANCE = 8;

export const meaningfullyInViewport = (rectLike) => {
  const rc = rectLike.getBoundingClientRect ? rectLike.getBoundingClientRect() : rectLike;
  return rc.top < window.innerHeight - EDGE_TOLERANCE && rc.bottom > EDGE_TOLERANCE;
};
